import { Phone } from "lucide-react";
import { motion } from "framer-motion";

export default function FloatingCallButton() {
  return (
    <motion.a
      href="tel:0652620747"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center h-16 w-16 rounded-full bg-green-600 hover:bg-green-500 text-white shadow-lg shadow-green-600/30 transition-colors duration-300"
      aria-label="Appeler RSE TAXI"
      data-testid="floating-call-btn"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <Phone className="h-7 w-7" />
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full border-2 border-green-500 animate-ping opacity-30" />
    </motion.a>
  );
}
